import { User } from "./user.model";

export interface Recipients{
    readonly groups?:RecipientsGroup[];
    readonly users?:Recipient[];
}
export interface Recipient{
    readonly id: number;
    readonly user:User
    readonly statusReply?:EReplyStatus;
    readonly guidToUser?:string;
    readonly dateAnswered?:Date;
    readonly groupName?:string;
    readonly mainAnswer?:string;
    readonly requiredAmount?: number;
    readonly approvedAmount?: number;
}
export interface RecipientsGroup{
    readonly id: number;
    readonly name: string;
    readonly color?:string;
    readonly users?:Recipient[];
}
export enum EReplyStatus{
    NotStarted=1, InProgress, Finished, Template, PendingApproval, Rejected, Approved
}